import { createTheme } from "@mui/material";

const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#735DA5', // Rich Purple 
        },
        secondary: {
            main: '#D3C5E5', // Light purple 
        },
        background: {
            default: '#F8FAFC', // Light Blue-Gray 
            paper: '#FFFFFF', // White 
        },
        text: {
            primary: '#1A1A2E', // Deep Dark Blue-Gray 
            secondary: '#735DA5', // Rich Purple 
        },
        custom: {
            cardPrimary: '#E8D7F1', // Pale Lavender 
            cardSecondary: '#F3F4F6', // Light Gray 
            accentTeal: '#00C4B4', // Teal 
            accentPurple: '#D4A5F5', // Light Purple 
            contrast: '#00246B', // Dark blue 
        },
    },
});

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#a583f2', // Rich Purple, 
        },
        secondary: {
            main: '#CADCFC', // Light blue 
        },
        background: {
            default: '#1A1A2E', // Deep Dark Blue-Gray 
            paper: '#2A2A40', // Lighter Blue-Gray 
        },
        text: {
            primary: '#E5E7EB', // Light Gray 
            secondary: '#FFFFFF', // White 
        },
        custom: {
            cardPrimary: '#E8D7F1', // Pale Lavender 
            cardSecondary: '#2A2A40', // Blue-Gray 
            accentTeal: '#00C4B4', // Teal 
            accentPurple: '#D4A5F5', // Light Purple 
            contrast: '#000612', // rgb(0, 6, 18) 
        },
    },
});

export { lightTheme, darkTheme };